import {
	// TEMP: using the plain logbook (no sections) until the Sections feature is decided
	// with Roger. Swap back to `sectionLogbookRoutesMESF` to re-enable sections.
	logbookRoutesMESF,
	TimeService,
	useHasPermission,
} from "@dexteel/mesf-core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import { Navigate, Route, Routes } from "react-router-dom";
import { workOrderRoutes } from "./routes/workOrderRoutes.routes";
import { taskListRoutes } from "./routes/taskListRoutes.routes";
import { homeRoutes } from "./routes/homeRoutes.routes";
import { mapRoutes } from "./routes/mapRoutes.routes";
import { assetDetailsRoutes } from "./routes/assetDetailsRoutes.routes";
import { templatesRoutes } from "./routes/templatesRoutes.routes";
import type { RouteConfig } from "./routes/types";
import UnauthorizedPage from "@/pages/errors/UnauthorizedPage";
import { WorkOrderModalsProvider } from "@/shared/work-orders-modals/context/work-order-modals.context";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

const routeSections = [
	{ routes: homeRoutes },
	{ routes: workOrderRoutes },
	{ routes: taskListRoutes },
	{ routes: logbookRoutesMESF },
	{ routes: mapRoutes },
	{ routes: assetDetailsRoutes },
	{ routes: templatesRoutes },
];

const CustomRoutes = () => {
	const hasPermissionTo = useHasPermission();

	const canAccessRoute = (route: RouteConfig): boolean => {
		if (route.permission) {
			return hasPermissionTo(route.permission);
		}
		return true;
	};

	return (
		<LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
			<WorkOrderModalsProvider>
				<Routes>
					<Route path="/unauthorized" element={<UnauthorizedPage />} />

					{routeSections.map((section, index) => {
						return section.routes.map((route) => {
							const canAccess = canAccessRoute(route);
							return (
								<Route
									key={`route-${route.path}`}
									path={route.path}
									element={
										canAccess ? (
											route.element
										) : (
											<Navigate to="/unauthorized" replace />
										)
									} />
							);
						});
					})}

					<Route path={"/"} element={<Navigate to={"/task-list/downday"} replace />} />
				</Routes>
			</WorkOrderModalsProvider>
		</LocalizationProvider>
	);
};

export { CustomRoutes };
